module.exports = __webpack_public_path__ + "static/media/icono_talleres.28a1b208.svg";